import { HOMEPAGE_PATHS } from "constants-lib/common"

const isHomePagePath = (pathname: string): boolean =>
  Object.values(HOMEPAGE_PATHS).some((homePath) => pathname === homePath)

export default isHomePagePath
